import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import eomPriceCodeService from "../services/eom-price-code-service";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import cogoToast from "cogo-toast";

const PriceCodeModal = ({ selectedRow, onCloseModal }) => {
  const [loading, setLoading] = useState(false);
  const [parent, setParent] = useState(selectedRow?.payor || "");
  const [chargeCode, setChargeCode] = useState(selectedRow?.unique || "");

  const [priceCode, setPriceCode] = useState(selectedRow?.price_code || "");
  const [factor, setFactor] = useState(selectedRow?.factor || "");
  const [fees, setFees] = useState(selectedRow?.fees || "");
  const [acqMin, setACQMin] = useState(selectedRow?.acq_max || "");
  const [acqMax, setACQMax] = useState(selectedRow?.acq_min || "");

  const [error, setError] = useState(false);

  const onSubmit = async () => {
    try {
      if (!acqMax || !acqMin || !factor || !fees) {
        setError(true);
        return;
      }
      var data = {
        payor: parent,
        unique: chargeCode,
        price_code: priceCode,
        acq_min: acqMin,
        acq_max: acqMax,
        factor: factor,
        fees: fees,
      };
      setLoading(true);

      await eomPriceCodeService.createData(data);
      setLoading(false);
      onCloseModal(true);
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error submitting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <div className="text-xl">{selectedRow?.id ? "Edit" : "Create"} </div>
      <div className="bg-white w-full mx-auto mt-6 mb-4 rounded h-full ">
        <div className="p-2 text-xs">
          <ul>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Payor
              </label>
              <input
                id="payor"
                name="payor"
                type="text"
                placeholder="Payor"
                disabled={true}
                value={parent}
                onChange={(e) => setParent(e.target.value)}
                className={`  border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />
            </li>

            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Charge Code
              </label>
              <input
                id="chargeCode"
                name="chargeCode"
                type="text"
                placeholder="Charge Code"
                disabled={true}
                value={chargeCode}
                onChange={(e) => setChargeCode(e.target.value)}
                className={`  border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Price Code
              </label>

              <input
                id="price_code"
                name="price_code"
                type="text"
                placeholder="Price Code"
                value={priceCode}
                disabled={true}
                onChange={(e) => setPriceCode(e.target.value)}
                className={` ${
                  error && priceCode.length === 0 ? "border-red-400" : ""
                } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />

              {error && priceCode?.length === 0 && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify price code
                </p>
              )}
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Factor
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>

              <input
                id="factor"
                name="factor"
                type="number"
                placeholder="Factor"
                value={factor}
                onChange={(e) => setFactor(e.target.value)}
                className={` ${
                  error && !factor ? "border-red-400" : ""
                } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />

              {error && !factor && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify price code
                </p>
              )}
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Fees
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>

              <input
                id="fees"
                name="fees"
                type="number"
                placeholder="Fees"
                value={fees}
                onChange={(e) => setFees(e.target.value)}
                className={` ${
                  error && !fees ? "border-red-400" : ""
                } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />

              {error && !fees && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify fees
                </p>
              )}
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                ACQ Amount
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <div className="flex">
                <span className="w-1/3">
                  <input
                    id="acqMin"
                    name="acqMin"
                    type="number"
                    placeholder="From"
                    value={acqMin}
                    onChange={(e) => setACQMin(e.target.value)}
                    className={` ${
                      error && !acqMin ? "border-red-400" : ""
                    } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                  />

                  {error && !acqMin && (
                    <p className="text-xs md:text-sm md:pt-1 text-hlred">
                      You must specify minimum amount
                    </p>
                  )}
                </span>

                <span className="w-1/3 ml-4">
                  <input
                    id="acqMax"
                    name="acqMax"
                    type="number"
                    placeholder="To"
                    value={acqMax}
                    onChange={(e) => setACQMax(e.target.value)}
                    className={` ${
                      error && !acqMax ? "border-red-400" : ""
                    } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                  />

                  {error && !acqMax && (
                    <p className="text-xs md:text-sm md:pt-1 text-hlred">
                      You must specify maximum amount
                    </p>
                  )}
                </span>
              </div>
            </li>
            <li className="text-center">
              <button
                disabled={loading}
                onClick={() => onSubmit()}
                className={
                  loading
                    ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    : "text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                }
              >
                SUBMIT
              </button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(PriceCodeModal)
);
